import { Route } from '@angular/router';

export const outletNotLoggedIn = (options: Route = {}): Route => {
    return Object.assign({
        outlet: "not_logged_in",
    }, options);
};
